module.exports = "/fonts/fa-solid-900.ttf?acf50f59802f20d8b45220eaae532a1c";